module.exports = __webpack_public_path__ + "img/153.ce6ac322.jpg";